import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import { SolutionsHeroType } from 'routes/Solutions/helpers'
import clsx from 'clsx'
import classes from './SolutionHero.module.scss'

export const SolutionHero = ({ ...props }: SolutionsHeroType) => {
  const {
    title,
    subtitle,
    subtitleAdditional,
    imageWidth,
    imageHeight,
    mobile1x,
    mobile2x,
    desktop1x,
    desktop2x,
    showAsRow,
  } = props
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={clsx(classes.section, showAsRow && classes.wrapper__row)}
    >
      <div className={classes.heading}>
        <Heading as={'h1'} size={'xxl'} center className={classes.title}>
          {title}
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          {subtitle}
        </Text>
        {subtitleAdditional && (
          <Text size={'lg'} center balance className={classes.subtitle}>
            {subtitleAdditional}
          </Text>
        )}
      </div>
      <div className={classes.visual}>
        <Picture
          className={classes.image}
          mobSrc1x={mobile1x.src}
          mobSrc2x={mobile2x.src}
          deskSrc1x={desktop1x.src}
          deskSrc2x={desktop2x.src}
          width={imageWidth}
          height={imageHeight}
          alt={title}
          fetchPriorityHigh
        />
      </div>
    </Block>
  )
}
